@if (dataSource && tableView) {
  @if (isStorageUnitsView) {
    <icz-storage-units-table
      class="grow"
      [tableId]="viewTableId!"
      [dataSource]="dataSource"
      [tableTitle]="tableTitle"
      [viewType]="StorageUnitView.STORAGE_UNITS_TABLE"
    >
      <ng-container afterTableTitle>
        <ng-container *ngTemplateOutlet="tableSelector"></ng-container>
      </ng-container>
      <ng-container tableTabs>
        <ng-container *ngTemplateOutlet="tableTabs"></ng-container>
      </ng-container>
      <ng-container noDataLabel>
        <ng-container *ngTemplateOutlet="noDataLabel"></ng-container>
      </ng-container>
    </icz-storage-units-table>
  } @else if (isStorageUnitFillersView) {
    <icz-storage-unit-fillers-table
      class="grow"
      [tableId]="viewTableId!"
      [tableTitle]="tableTitle"
      [dataSource]="dataSource"
    >
      <ng-container afterTableTitle>
        <ng-container *ngTemplateOutlet="tableSelector"></ng-container>
      </ng-container>
      <ng-container tableTabs>
        <ng-container *ngTemplateOutlet="tableTabs"></ng-container>
      </ng-container>
      <ng-container noDataLabel>
        <ng-container *ngTemplateOutlet="noDataLabel"></ng-container>
      </ng-container>
    </icz-storage-unit-fillers-table>
  } @else {
    <icz-documents-table
      class="grow"
      [tableId]="viewTableId!"
      [tableTitle]="tableTitle"
      [viewType]="tableView"
      [isUnitView]="isUnitView"
      [dataSource]="dataSource"
      [allowOpenQuickPreview]="!isStorageUnitsView && !isStorageUnitFillersView"
    >
      <ng-container afterTableTitle>
        <ng-container *ngTemplateOutlet="tableSelector"></ng-container>
      </ng-container>
      <ng-container tableTabs>
        <ng-container *ngTemplateOutlet="tableTabs"></ng-container>
      </ng-container>
      <ng-container noDataLabel>
        <ng-container *ngTemplateOutlet="noDataLabel"></ng-container>
      </ng-container>
    </icz-documents-table>
  }
}

<ng-template #tableSelector>
  @if (isUnitView) {
    <icz-form-autocomplete
      class="ml-16 table-view-selector"
      [options]="selectorOptions"
      [value]="activeSelectorValue"
      (valueChange)="selectorValueChanged($event)"
      [showValidationStatus]="false"
      [clearable]="false"
    ></icz-form-autocomplete>
  }
</ng-template>

<ng-template #tableTabs>
  <icz-tabs
    class="grow"
    [tabs]="(tabs$ | async)!"
    [activeTab]="activeTab"
    [shouldNavigate]="false"
    (tabClick)="viewTabChanged($event)"
  ></icz-tabs>
</ng-template>

<ng-template #noDataLabel>
  <icz-label [label]="isStorageUnitsView ? 'Žádné ukládací jednotky' : 'Žádné ukončené dokumenty'"></icz-label>
</ng-template>
